const Existing = ({existing, option}: iExisting) => {
  return (
    <>
      <div className=" flex justify-between mt-7">
        <p className=" text-gray-6">موجودی</p>
        <p className="text-gray-6">
          {existing} {option}
        </p>
      </div>
    </>
  );
};

export default Existing;
